import { FC } from 'react';
import styled from 'styled-components';

import { remify } from '#/service/utils';

const TabsContainer = styled.div`
  display: flex;
  gap: ${remify(48)};
  margin-bottom: ${remify(48)};
  justify-self: center;
`;

const Tab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 0 0 ${remify(8)} 0;
  font: var(--fontStyleSubtitle);
  color: var(--pageHeadingForeground);
  cursor: pointer;
  position: relative;
  transition: opacity 0.2s;
  opacity: ${({ $active }) => ($active ? '1' : '0.6')};

  &:hover {
    opacity: 1;
  }

  ${({ $active }) =>
    $active &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 3px;
      background: var(--tabMenuHighlightBackground);
    }
  `}
`;

export interface ProductTab {
  id: string;
  label: string;
}

export interface ProductTabsProps {
  activeTab: string;
  availableTabs: ProductTab[];
  onTabChange: (tabId: string) => void;
}

export const ProductTabs: FC<ProductTabsProps> = ({
  activeTab,
  availableTabs,
  onTabChange,
}) => {
  if (availableTabs.length <= 1) {
    return null;
  }

  return (
    <TabsContainer>
      {availableTabs.map(({ id, label }) => (
        <Tab
          $active={activeTab === id}
          data-testid={`product-tab-${id.toLowerCase()}`}
          key={id}
          onClick={() => onTabChange(id)}
        >
          {label}
        </Tab>
      ))}
    </TabsContainer>
  );
};
